import React from 'react';
import RecentlyViewed from './RecentlyViewed';
import GoogleRelated from './GoogleRelated';
import { useShopifyProduct } from '../../../../api/shopify/ShopifyProduct';
import { ShopifyProductTransformer } from '@jbhi-fi/components/src/Shopify/transformers/ShopifyProductTransformer';
import { useSmartModuleContext } from '../SmartModuleProvider';
import { useTrackingContext } from '@jbhi-fi/components/src/Tracking';
import { SmartModuleSettings } from '../../../../../global';

export type SmartModuleType = 'frequentlyBoughtTogether' | 'recommendedForYou' | 'recentlyViewed';

type SmartModuleWrapperProps = {
  settings: SmartModuleSettings;
  isMarketplaceProduct?: boolean;
  location: 'pdpTop' | 'pdpBottom' | 'pdpMiddle' | 'productAttach' | 'homePage' | 'search';
  variant?: 'carousel' | 'list';
};

export const SmartModuleWrapper = ({
  settings,
  isMarketplaceProduct,
  location,
  variant = 'carousel',
}: SmartModuleWrapperProps) => {
  const { smartModulesData, isEnhancedGoogleRecommendationsEnabled } = useSmartModuleContext();
  const { tracker } = useTrackingContext();

  const { type, title } = settings;

  const pdpBottomSmartModuleSettings = window.smartModuleSettings.pdpBottom;
  const isFBTBottomEnabled =
    pdpBottomSmartModuleSettings?.type === 'frequentlyBoughtTogether' && pdpBottomSmartModuleSettings?.isEnabled;

  const getButtonType = () => {
    if (isFBTBottomEnabled) return 'primary';
    if (type === 'frequentlyBoughtTogether') return 'secondary';
    return 'primary';
  };

  if (!smartModulesData[`${type}AlgoliaData`]) return null;

  if (type === 'recentlyViewed')
    return (
      <RecentlyViewed
        data={smartModulesData[`${type}AlgoliaData`]}
        settings={settings}
        page={tracker.context ?? ''}
        isEnhancedGoogleRecommendationsEnabled={isEnhancedGoogleRecommendationsEnabled}
      />
    );

  if (settings?.googleRecModelType && isMarketplaceProduct) return null;

  return (
    <GoogleRelated
      data={smartModulesData[`${type}AlgoliaData`]}
      title={title}
      type={type as 'frequentlyBoughtTogether' | 'recommendedForYou'}
      page={tracker.context ?? ''}
      location={location}
      settings={settings}
      buttonType={getButtonType()}
      variant={variant}
      isEnhancedGoogleRecommendationsEnabled={isEnhancedGoogleRecommendationsEnabled}
    />
  );
};
